import React, { useEffect, useRef } from "react";
import "./App.css";
import { ThemeProvider } from "@mui/material";
import { useLocation } from "react-router-dom";
import theme from "./Theme";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LogUser } from "./utils/restAPI";

import {
  getFunds,
  getStrategies,
  getLots,
  getTrades,
  getDeletes,
  getCustodians,
  getFtp,
  getTickers,
  getRouters,
  getBrokers,
  TradeCustodianFile,
  addNewBrokers,
  addNewTrades,
  addNewOrders,
  addNewManual,
  addNewFill,
  deleteTrades,
  getAccountingSystem,
  addNewCommission,
  TradeCustodianAccountingFile,
  getUserPreference,
  getHistoricalData,
  addNewCustodians,
  modifyCustodians,
  deleteCustodian,
  modifyBrokers,
  deleteBroker,
  addNewFunds,
  modifyFunds,
  saveMarketData,
  saveMarketDataBloomberg,
  deleteFund,
  addNewStrategy,
  modifyStrategy,
  deleteStrategy,
  modifySignal,
  getFees,
  getManagers,
  getNotifications,
  getCustomFunds,
  modifyNotification,
  modifyUnreadNotification,
  modifySignalValue,
  getAllocationData,
  stageOneOfSleeve,
  stageTwoOfRebalance,
} from "./Redux/Actions/todoActions";

import { updateLoading, getLoading } from "./Redux/Reducers/todoReducers";
import { getUserState } from "./Redux/Reducers/userReducer";
import {
  getUser,
  getUserInfo,
  removeUser,
  getApiInfo,
} from "./Redux/Actions/UserActions";
import { Spinner } from "./component/spinner";
import { ToastContainer, toast } from "react-toastify";
import MainRoutes from "./MainRoutes";
import Sockets from "./utils/sockets";
import { customizedFunds } from "./component/Methods";

function ping(client) {
  if (client && client.readyState === WebSocket.OPEN) {
    client.send("ping");
  }
}

function App() {
  const user = useSelector(getUserState);
  const { managers, isInvestor } = useSelector((state) => state.todos);
  const socketapiData = useSelector((state) => state?.users?.apiInfo);
  const socketuser = useSelector((state) => state?.users?.userInfo);
  const token = localStorage.getItem("key");
  const loading = useSelector(getLoading);
  var intervalId = 0;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const apiDataRef = useRef(socketapiData);
  const userRef = useRef(socketuser);

  useEffect(() => {
    apiDataRef.current = socketapiData;
    userRef.current = socketuser;
  }, [socketapiData, socketuser]);

  useEffect(() => {
    let localUser = localStorage.getItem("user");
    if (localUser) {
      let userAuth = JSON.parse(localUser);
      dispatch(getUser(userAuth));
    }
  }, []);

  const parseMsg = (data) => {
    if (data) {
      if (data.action === "seed") {
        if (data?.data) {
          dispatch(getBrokers(data?.data?.brokers));
          dispatch(getManagers(data?.data?.managers));
          dispatch(getRouters(data?.data?.routers));

          if (data?.data?.managers && data?.data?.managers.length > 0) {
            const manager = data?.data?.managers;
            const findFund = manager[0]?.funds;
            const fundsArray = Object.values(findFund);
            dispatch(getFunds(fundsArray));
            const findAccounting = manager[0]?.accountingSystems;
            const AccountingArray = Object.values(findAccounting);
            dispatch(getAccountingSystem(AccountingArray));
            dispatch(getStrategies(data?.data?.strategies));

            const combinedLots = fundsArray.reduce((acc, fund) => {
              return acc.concat(fund.lots);
            }, []);

            console.log(combinedLots);

            dispatch(
              getCustomFunds(
                customizedFunds(
                  combinedLots,
                  fundsArray,
                  data?.data?.strategies
                )
              )
            );
            dispatch(getLots(combinedLots));
          } else {
            const userStrategies = data?.data?.strategies?.filter(
              (strategy) => strategy?.owner?.value === user?.username
            );
            dispatch(getStrategies(userStrategies));
            const strategyIds = userStrategies?.map(
              (strategy) => strategy.strategyId
            );

            const lotsData = data?.data?.lots?.filter((lot) =>
              strategyIds.includes(lot?.strategy)
            );
            dispatch(getLots(lotsData));
          }

          dispatch(getHistoricalData(data?.data?.historicaltrades));
          dispatch(getCustodians(data?.data?.custodians));
          dispatch(getTickers(data?.data?.tickers));
          dispatch(getTrades(data?.data?.trades));
          dispatch(getDeletes(data?.data?.trades));
          dispatch(getUserPreference(data?.data?.userPreference));
          dispatch(getFees(data?.data?.fees));
          dispatch(getNotifications(data?.data?.notifications));
        }
        if (location.pathname === "/login" || location.pathname === "/") {
          if (data?.data?.managers && data?.data?.managers.length == 0) {
            navigate("/portfolio");
          } else {
            navigate("/dashboard");
          }
        } else {
          navigate(location.pathname);
        }

        return null;
      }

      if (data.action === "new_broker") {
        return dispatch(addNewBrokers(data?.data?.broker));
      }
      if (data.action === "modify_broker") {
        dispatch(modifyBrokers(data?.data?.broker));
      }
      if (data.action === "delete_broker") {
        dispatch(deleteBroker(data?.data?.broker));
      }
      if (data.action === "new_custodian") {
        return dispatch(addNewCustodians(data?.data?.custodian));
      }
      if (data.action === "modify_custodian") {
        dispatch(modifyCustodians(data?.data?.custodian));
      }
      if (data.action === "delete_custodian") {
        dispatch(deleteCustodian(data?.data?.custodian));
      }
      if (data.action === "new_fund") {
        return dispatch(addNewFunds(data?.data?.fund));
      }
      if (data.action === "modify_fund") {
        dispatch(modifyFunds(data?.data?.fund));
      }
      if (data.action === "market_data") {
        dispatch(saveMarketData(data?.data));
      }

      if (data.action === "market_data_bloomberg") {
        dispatch(saveMarketDataBloomberg(data?.data));
      }

      if (data.action === "delete_fund") {
        dispatch(deleteFund(data?.data?.fund));
      }
      if (data.action === "new_strategy") {
        return dispatch(addNewStrategy(data?.data));
      }
      if (data.action === "modify_strategy") {
        dispatch(modifyStrategy(data?.data?.strategy));
      }
      if (data.action === "delete_strategy") {
        dispatch(deleteStrategy(data?.data?.strategy));
      }

      if (data.action === "get_accounting_eod") {
        dispatch(TradeCustodianAccountingFile(data?.data));
      }
      if (data.action === "new_trades" && data?.data) {
        dispatch(updateLoading(false));
        toast.success("New trades are added.");
        dispatch(addNewTrades(data?.data));
        dispatch(getLots([]));
      }
      if (data.action === "modify_orders" && data?.data) {
        toast.success("Trade is Updated.");
        dispatch(addNewOrders(data));
        dispatch(getLots([]));
      }
      if (data.action === "modify_trade_fills" && data?.data) {
        dispatch(addNewManual(data?.data));
        dispatch(getLots([]));
      }
      if (data.action === "modify_trade_commissions" && data?.data) {
        dispatch(addNewCommission(data));
      }

      if (data.action === "update_fills" && data?.data?.fill) {
        dispatch(addNewFill(data?.data?.fill));
        dispatch(getLots([]));
      }
      if (data.action === "generate_file") {
        return dispatch(TradeCustodianFile(data?.data));
      }
      if (data.action === "delete_trades" && data?.data) {
        toast.success("Trade is Deleted.");
        return dispatch(deleteTrades(data));
      }
      if (data.action === "post_ftp") {
        return dispatch(getFtp(data?.data));
      }
      if (data.action === "new_signal" && data) {
        toast.success("Strategy Signal Updated.");
        dispatch(modifySignal(data));
      }
      if (data.action === "new_notification" && data) {
        dispatch(modifyNotification(data));
      }
      if (data.action === "modify_notifications" && data) {
        dispatch(modifyUnreadNotification(data));
      }
      if (data.action === "compare_signal" && data) {
        dispatch(modifySignalValue(data?.data));
      }
      if (data.action === "rebalancer_stage_one" && data) {
        dispatch(stageOneOfSleeve(data?.data));
      }
      if (data.action === "rebalancer_stage_two" && data) {
        dispatch(stageTwoOfRebalance(data?.data));
      }

      if (data.action === "get_fund_allocation" && data) {
        dispatch(getAllocationData(data?.data?.allocationsData));
      }
      if (data.action === "fund_allocation_response" && data) {
        toast.success(data?.data?.message);
      }
    }
    dispatch(updateLoading(false));
  };

  useEffect(() => {
    if (
      Object.keys(socketapiData).length > 0 &&
      Object.keys(socketuser).length > 0
    ) {
      dispatch(updateLoading(true));
      const req = '{"action": "seed"}';
      window?.clientSocks.send(req);
    }
  }, [socketapiData, socketuser]);

  useEffect(() => {
    if (user && !window?.clientSocks) {
      dispatch(updateLoading(true));

      async function fetchUser(username, password) {
        const response = await LogUser({
          username: username,
          password: password,
        });

        if (response) return response.token;
        else return null;
      }

      async function initiateWebSocketConnection(user) {
        const token = await fetchUser(user.username, user.password);
        if (token) {
          const url = `${process.env.REACT_APP_URL}?token=${token}`;
          const client = new WebSocket(url);
          window.clientSocks = client;

          if (window?.clientSocks) {
            window.clientSocks.onerror = function (error) {
              dispatch(updateLoading(false));
              toast.error("User Not Authorized. Connection Failed.");
            };
            window.clientSocks.onopen = function (e) {
              if (!localStorage.getItem("threshold")) {
                localStorage.setItem("threshold", 60);
              }

              intervalId = setInterval(() => {
                ping(window.clientSocks);
              }, 120000);
            };

            window.clientSocks.onmessage = function (event) {
              var data = JSON.parse(event.data);
              if (data.action === "login") {
                dispatch(updateLoading(true));
                dispatch(getUserInfo(data?.data?.user));
                dispatch(getApiInfo(data?.data));
                const key = data.data.user.refreshToken;
                localStorage.setItem("key", key);
              }
              if (data.action == "download") {
                const handleDownload = async (file) => {
                  try {
                    const { readData } = Sockets(
                      apiDataRef.current,
                      userRef.current
                    );
                    const result = await readData(file);
                    const JSONmsg = JSON.parse(result);
                    console.log("seed", JSONmsg);
                    parseMsg(JSONmsg);
                  } catch (error) {
                    console.error("Error during file download:", error);
                    toast.error("Failed to download data from server.");
                  }
                };
                handleDownload(data.file);
              } else {
                parseMsg(data);
              }
            };

            window.clientSocks.onclose = function (event) {
              clearInterval(intervalId);
              dispatch(removeUser());
              navigate("/login");
              window.clientSocks = null;
            };
          }

          dispatch(updateLoading(false));
        } else {
          dispatch(updateLoading(false));
        }
      }

      initiateWebSocketConnection(user);
    }
  }, [user]);

  return (
    <ThemeProvider theme={theme}>
      {loading && <Spinner />}
      <ToastContainer />
      {managers ? <MainRoutes token={token} managers={managers} /> : null}
    </ThemeProvider>
  );
}

export default App;
